module.exports = "/_next/static/images/ourPartnersFrontierCommunicationsLogo-f706fade3b2114866e0dfd03ea44f7df.webp";